import React from 'react';
import { Base } from './Base';
import { Text, TextLink } from './Text';
import { Link } from 'react-router-dom';
import { ActionIcon } from './icons';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import { formatDate } from 'src/utils/misc';
import { getDestinationType, getObjectLink } from './util';

interface EFActionOpenProps {
  showDate?: string;
  owner: string;
  action: {
    id: string;
    notes: string;
  };
  object: {
    id: string;
    name: string;
    type: string;
    assessmentId?: string;
  };
  truncate?: boolean;
  isToday: boolean;
}

export const EFActionOpen: React.FC<EFActionOpenProps> = ({ showDate, action, object, truncate, isToday }) => {
  return (
    <Base
      iconComponent={<ActionIcon />}
      constentComponent={
        <Text nowrap={truncate}>
          {showDate && <Text className="sdate">{formatDate(showDate)}</Text>}
          Action{' '}
          <Link
            to={`${getObjectLink(object)}#actions`}
            onClick={() =>
              mpEvent(MPEvents.Link, {
                source: {
                  value: ['Timeline'],
                },
                destination: {
                  value: [getDestinationType(object.type)],
                  params: {
                    id: object.id,
                  },
                },
                tags: ['TIMELINE', 'ACTIONS'],
              })
            }
          >
            <TextLink>{action.notes}</TextLink>
          </Link>{' '}
          {isToday && 'is '}due
        </Text>
      }
    />
  );
};
